import React, { useEffect, useState } from 'react';
import { ChevronDown, Search, X, Filter, RefreshCw, Upload } from 'lucide-react';
import QuestionDialog from './QuestionDialog';
import { Button, ButtonGroup, Card } from '@themesberg/react-bootstrap';
import { getDataWithPageTitle, getQuestionsColumn } from './utils.js';
import NewTable from '../../components/common/NewTable.js';
import FilterOrders from '../oms/orders/FIlterOrders.js';
import ExportButton from '../oms/orders/components/ExportButton.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faRefresh, faSliders } from '@fortawesome/free-solid-svg-icons';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import CommonModal from './component/CommonModal.js';
import { useDispatch } from 'react-redux';
import { updateSpinnerState } from '../../actions/spinner.js';
import { updateToastInfo } from '../../actions/settings.js';

const dummyQuestions = [
  { id: 1, text: 'What is the storage capacity?', type: 'Input Text', status: 'Assigned', answerOptions: '(User-entered text)' },
  { id: 2, text: 'Is the screen damaged?', type: 'Single Select (Radio Button)', status: 'Not Assigned', answerOptions: ['No scratches', 'Minor scratches', 'Major damage'] },
  { id: 3, text: 'What issues does the device have?', type: 'Multi Select (Check Box)', status: 'Assigned', answerOptions: ['Battery issues', 'Camera not working', 'Touchscreen problem', 'Speaker Issue'] },
];

const ExchangeQuestions = ({
 title
}) => {
  const [questions, setQuestions] = useState(dummyQuestions);
  const [searchTerm, setSearchTerm] = useState('');
  const [tableData, setTableData] = useState([]);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [dialogMode, setDialogMode] = useState('view');
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [openFilter,setOpenFilter] = useState(false)
  const [viewData,setViewData] = useState({})
  const [showView,setShowView] = useState(false)

  const dispatch = useDispatch()

  const onActionClick = (option,data) => {

    if(option == "view" || option == "View")
    {

     setViewData(data)
     setShowView(true)

    }

    if(option == "Edit" || option == "Edit")
    {
     onEdit(data?.objectId)
    }

    if(option == "Assign this Template")
    {
      assignedToTempate()
    }

    if(option == "Clone")
    {
      cloneData(data?.objectId)
    }

 };

 const onRowSelect = (selected, objectId) => {


 };
 const navigate = useNavigate()

  let {tableColumns,onDelete,onEdit,onCreate,getData,assignedToTempate,cloneData} = getDataWithPageTitle(title,onActionClick,onRowSelect,navigate)

console.log(getData)
 
const getTableData = async () => {



  try{

    dispatch(updateSpinnerState(true))
     const data = await getData()

     setTableData(data || [])
    dispatch(updateSpinnerState(false))
  }catch(e)
  {
    dispatch(updateSpinnerState(false))
    dispatch(
      updateToastInfo({
        show: true,
        type: 'danger',
        title: 'Failed!',
        message: t(e.message),
      })
    );
  }

}

 
  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleViewQuestion = (question) => {
    setSelectedQuestion(question);
    setDialogMode('view');
    setIsDialogOpen(true);
  };

  const handleEditQuestion = (question) => {
    setSelectedQuestion(question);
    setDialogMode('edit');
    setIsDialogOpen(true);
  };

  const handleDeleteQuestion = (questionId) => {
    setQuestions(questions.filter(q => q.id !== questionId));
  };

  useEffect((each) => {
    getTableData()
  },[])
  return (
    <div className="" style={{width:"100%"}}>
      <Card>
        <Card.Body style={{backgroundColor:"rgb(245,248,251)"}}>
          <h1 className="text-primary">{title == "question" ? "Exchange Questions" : "Exchange Template"}</h1>
          
          <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#F5F8FB",
    marginBlock: "10px",
    padding: "5px",
  }}
>
  <div style={{ borderRadius: "0px" }}>
    <div className="input-group" style={{ borderRadius: "0px" }}>
      <span style={{ borderRadius: "0px" }} className="input-group-text">
        <Search style={{ borderRadius: "0px" }} size={18} />
      </span>
      <input
        type="text"
        placeholder="Search within the table"
        value={searchTerm}
        onChange={handleSearch}
        style={{
          borderRadius: "0px",
          borderRight: searchTerm ? "none" : "", // Removes right border when clear button is visible
        }}
        className="form-control"
      />
      {searchTerm && (
        <Button
          variant="white"
          style={{
            borderRadius: "0px",
            border: "1px solid #D1D7E0",
            borderLeft: "none", // Removes left border to blend with input
          }}
          onClick={() => setSearchTerm("")}
          tabIndex="-1" // Prevents focus on the button
        >
          <X size={18} />
        </Button>
      )}
    </div>
  </div>

  <Button
    variant="white"
    onClick={() => {
      navigate(onCreate?.url)
    }}
    style={{
      width: "250px",
      height: "38px",
      borderRadius: 0,
      backgroundColor: "white",
      borderRight: "none", // Ensures no right border
    }}
    size="sm"
  >
    <FontAwesomeIcon icon={faEdit} />
    &nbsp;&nbsp;{t(onCreate?.text)}
  </Button>
</div>

          
          <div className="" style={{display:"flex",justifyContent:"space-between",backgroundColor:"white", marginBlock:"10px",padding:"5px",alignItems:"center"}}>

            <div></div>
                      <ButtonGroup className="gap-2">
                        {/* {pageTitle ===
                          returnOrderStatus.REFUND_INITIATED + ' Orders' && ( */}
                        
                       
                        {/* <Button
                          variant={openFilter ? 'primary' : 'white'}
                          onClick={() => {
                            setOpenFilter(!openFilter)
                          }}
                          style={{
                            width: '150px',
                            height: '38px',
                            borderRadius: 0,
                            backgroundColor:!openFilter ? "#F5F8FB" : ""

                          }}
                          size="sm"
                        >
                          <FontAwesomeIcon icon={faSliders} />
                          &nbsp;&nbsp;{t('Filter')}
                        </Button> */}

      <Button
                          variant="white"
                          onClick={getTableData}
                          style={{
                            width: '150px',
                            height: '38px',
                            borderRadius: 0,
                            backgroundColor:"#F5F8FB"
                          }}
                          size="sm"
                        >
                          <FontAwesomeIcon icon={faRefresh} />
                          &nbsp;&nbsp;{t('Refresh')}
                        </Button>
                        
                        <ExportButton
                      
                          variant={"#F5F8FB"}
                          data={tableData}
                          columns={ title == "question" ? [{
                            key:"objectId", field : "questionId"
                          },{
                            key:"text", field : "text"
                          },{
                            key:"type", field : "type"
                          },{
                            key:"status", field : "status"
                          },{
                            key:"answerOptions", field : "answerOptions"
                          }] : [{
                            key:"objectId", field : "templateId"
                          },{
                            key:"products", field : "products"
                          },{
                            key:"categorys", field : "category"
                          },{
                            key:"questions", field : "questions"
                          },{
                            key:"noOfQuestions", field : "noOfQuestions"
                          },{
                            key:"exchangeValue", field : "exchangeValue"
                          },{
                            key:"exchangeBonus", field : "exchangeBonus"
                          }]}
                          fileName={title}
                        />
                      </ButtonGroup>
                    </div>
                  {/* { openFilter && (
                    <FilterOrders
                      data={[]}
                      setData={() => {}}
                      openFilter={true}
                      pageType={""}
                      setQueryParam={() => {}}
                    />
                  )}  */}
     
          

          
          <NewTable
        id="QuestionList"
        data={tableData || []}
        columns={tableColumns}
      />
        </Card.Body>
      </Card>

      {selectedQuestion && (
        <QuestionDialog 
          isOpen={isDialogOpen} 
          onClose={() => setIsDialogOpen(false)}
          mode={dialogMode}
          questionData={selectedQuestion}
        />
      )}

<CommonModal show={showView} onClose={() => {setShowView(false)}} type={title} data={viewData} />;
    </div>
  );
};

export default ExchangeQuestions;
